import React from 'react';
import PropTypes from 'prop-types';
import { upperFirst, toLower } from 'lodash';

import { CourseLink } from '../../../shared/links/ProfileLink';
import { formatPrize } from '../../../utils/money';
import { yardsToFurlongs } from '../../../utils/distance';

const CourseCell = ({
    courseStyleName,
    courseRpAbbrev3,
    courseUid,
    raceClass,
    raceDescription,
    distanceYard,
    goingTypeServicesDesc,
    prizeSterling,
}) => (
    <span>
        <CourseLink
            courseStyleName={courseStyleName}
            courseShortName={upperFirst(toLower(courseRpAbbrev3))}
            courseUid={courseUid}
        />
        &nbsp;<wbr />
        <span className="hidden-sm-down">
            {yardsToFurlongs(distanceYard)}
            {goingTypeServicesDesc}
        </span>
        &nbsp;<wbr />
        <span className="hidden-xs-down">
            {raceClass && 'C'}
            {raceDescription}
        </span>
        &nbsp;<wbr />
        <span className="hidden-sm-down">
            {formatPrize(prizeSterling)}
        </span>
    </span>
);

CourseCell.propTypes = {
    courseStyleName: PropTypes.string,
    courseRpAbbrev3: PropTypes.string,
    courseUid: PropTypes.number,
    raceClass: PropTypes.string,
    raceDescription: PropTypes.string,
    distanceYard: PropTypes.number,
    goingTypeServicesDesc: PropTypes.string,
    prizeSterling: PropTypes.string,
};

export default CourseCell;



// WEBPACK FOOTER //
// ./src/js/human/form/components/CourseCell.jsx